export function calcTimeDifference(start: string, end: string) {
    if (end === null) {
        return;
    } else {
        const roundTimestampToMinutes = function (dateTimeString: string) {
            let date = new Date(dateTimeString);
            date.setSeconds(0, 0);
            return new Date(date).getTime();
        };

        let startTime = roundTimestampToMinutes(start);
        let endTime = roundTimestampToMinutes(end);

        let diff = Math.floor((endTime - startTime) / 1000);

        const hours = String(Math.floor(diff / 3600)).padStart(2, "0");
        const minutes = String(Math.floor((diff % 3600) / 60)).padStart(2, "0");
        // const seconds = String(diff % 60).padStart(2, '0');

        if (hours === "00" && minutes === "00") {
            return `< 1 min`;
        } else {
            return `${hours}:${minutes}`;
        }
    }
}